import { createContext } from 'react';

/** Figma LineTab / SolidTab 에 대응한다. */
export type TabVariant = 'line' | 'solid';

interface TabContextProps {
    variant: TabVariant;
    setCurrentId: (v: string) =>void;
}

const TabContext = createContext<TabContextProps>({} as TabContextProps);

export default TabContext;
